import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ActionBar = ({ children, className, flexType }) => (
  <div className={`gn-bar gn-actionBar ${className}`}>
    <div className="gn-divider" />
    <div className={classNames('gn-actionBar__wrapper', { [`gn-actionBar__wrapper--${flexType}`]: !!flexType })}>
      {children}
    </div>
  </div>);

ActionBar.propTypes = {
  flexType: PropTypes.oneOf([
    'startToEnd',
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ActionBar;
